import styled from 'styled-components'

export const Component = styled.input`
  appearance: none;
  box-sizing: border-box;
  outline: none;
  margin: 0;
  width: ${({ width }) => (width ? `${width}px` : '100%')};
  border: 1px solid var(--text-light);
  border-radius: 10px;
  padding: 16px;
  font-size: var(--font-size-sm);
  color: var(--text-tertiary);
`
